import { render, staticRenderFns } from "./page-profile.vue?vue&type=template&id=e1cacc34"
import script from "./page-profile.vue?vue&type=script&lang=ts"
export * from "./page-profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports